import {FileValidationResult} from "../models/types/convert-document-ai-modal.types";

/**
 * Builds the user-facing message from the list of rejected files.
 * Returns null when nothing was rejected.
 */
export const buildRejectionMessage = (rejected: FileValidationResult["rejected"]): string | null => {
    if (rejected.length === 0) {
        return null;
    }
    const summary = rejected.map(item => `„${item.name}” - ${item.reason}`).join("; ");
    return rejected.length === 1
        ? `Nie dodano pliku: ${summary}.`
        : `Nie dodano ${rejected.length} plików: ${summary}.`;
};
